module.exports = __webpack_public_path__ + "static/media/servion.ef20e7bb.svg";